export interface CollectionHeaderSearchCriteria {

    draftInvoiceNoList: string[] | null,
    receiptNoList: string[] | null,
    billToCompany: string | null,
    draftInvoiceNo: string | null,
    subType: string | null,
    dateFrom: Date | null,
    dateTo: Date | null,
    collectionDateFrom: Date | null,
    collectionDateTo: Date | null,
    updatedBy: string | null,
    notYetFinal: string | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_COLLECTION_HDR_SEARCH_CRITERIA: CollectionHeaderSearchCriteria = {
    draftInvoiceNoList: [],
    receiptNoList: [],
    billToCompany: null,
    subType: null,
    dateFrom: null,
    dateTo: null,
    draftInvoiceNo: null,
    collectionDateFrom: null,
    collectionDateTo: null,
    updatedBy: null,
    notYetFinal: "N"
}
